<template>
    <div class="banner-pdv">
        <div class="container pdv-bg-image d-flex justify-content-start align-items-center">
            <div class="d-sm-inline-flex">
                <div class="pt-1">
                    <span class="icon-ui icon-pdv-location">
                    </span>
                </div>
                <div class="ml-2">
                    <h1 class="h2"><b v-html="__('messages.points_pricetravel', [siteConfig.appName])"></b></h1>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
const site = window.__pt.settings.site;
export default {
    props: {
        msg: String,
    },
    data() {
        return {
            name: "Nombre",
            siteConfig: site,

        };
    },
};
</script>
    